<template>
<div class="HelpDoc">
  <!-- <div class="title">
      <div
        v-for="(anchor,index) in titles"
        :style="{ padding: `10px 0 10px ${anchor.indent * 20}px` }"
        @click="handleAnchorClick(anchor,index)"
        :class="index==tabIndex?'active':''"
      :key="index">
        <a style="cursor: pointer">{{ anchor.title }}</a>
      </div>
    </div>
  <v-md-preview class="previewContainer" :text="md" ref="preview" /> -->
  <div class="box">
      <v-md-editor
      v-model="md"
      :toolbar="{}"
      height="100%"
      :default-show-toc="true"
      :default-fullscreen="false"
      :include-level="[1, 2,3]"
      ref="previews"
      :model="'preview'"
    />
  </div>
</div>
</template>

<script>
export default {
  inject: ['reload'],
  data() {
    return {
      md:require("../../assets/md/hlepDoc.md")
    }
  },
  created() {
  },
  computed: {
    screenData() {
      return this.$store.state.screen;
    },
  },
  watch:{
    screenData() {
      // this.reload()
    }
  },
  mounted() {
    // v-md-editor__toc-nav-item
    setTimeout(() => {
      // console.log(this.$refs);
      const { previews } = this.$refs;
      const heading1 = previews.$el.querySelectorAll(`.v-md-editor__toc-nav-item`);
      // console.log(heading1.length);
      // console.log(heading1);
      const arry=Array.from(heading1)
      // console.log(arry);
      arry.forEach((item,index)=>{
        item.addEventListener('click', () => {
          arry.forEach(items=>{
            items.style.color = `#2c3e50`
          })
          // console.log(index);
          item.style.color = `#1890ff`
        })
      })
    }, 200);
    // this.$nextTick(() => {
    //   console.log(this.$refs);
    //   const { previews } = this.$refs;
    //   const heading1 = previews.$el.querySelectorAll(`.v-md-editor__toc-nav-item`);
    //   console.log(heading1.length);
    //   console.log(heading1);
    //   const arry=Array.from(heading1)
    //   console.log(arry);
    //   arry.forEach((item,index)=>{
    //     item.addEventListener('click', () => {
    //       arry.forEach(items=>{
    //         items.style.color = `#2c3e50`
    //       })
    //       console.log(index);
    //       item.style.color = `#1890ff`
    //     })
    //   })
    // })
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.HelpDoc{
  // height: 890px;
  height: 100%;
  padding:10px 20px 20px;
  box-sizing: border-box;
  // overflow: scroll;
  .box{
    height: 100%;
    position: relative;
  }
  .title{
    position: fixed;
    left: 240px;
    top: 20px;
    z-index: 100;
  }
  .previewContainer{
    // height: 890px;
    // overflow: scroll;
    .github-markdown-body{
      // overflow-y: scroll;
    }
  }
}
</style>
<style lang="scss">
.HelpDoc {
  .v-md-editor__left-area, .v-md-editor__right-area{
    width: 200px !important;
    border-width: 1px !important;
  }
  .v-md-editor__toolbar{
    .v-md-editor__toolbar-item{
      display: none;
    }
    .v-md-editor__toolbar-divider:before{
      border: none;
    }
  }
  .v-md-editor__main{
    .v-md-editor__editor-wrapper{
      // display: block;
      display: none;
    }
    .vuepress-markdown-body{
      img{
        // width: 100%;
        // height: 200px;
      }
    }
  }
}
</style>
